import React from 'react'
import { ChevronDown } from 'lucide-react'
import { useTranslation } from '../../hooks/useTranslation'
import DropdownMenu from '../dropdown/DropdownMenu'
import { navigationData } from '../../data/navigation'

const NavigationMenu: React.FC = () => {
  const { t, isRTL } = useTranslation()

  return (
    <div className={`flex items-center space-x-8 ${isRTL ? 'rtl:space-x-reverse' : ''}`}>
      {navigationData.map((item) => (
        <div key={item.id} className="relative group">
          <button 
            className={`flex items-center space-x-1.5 text-text-2 hover:text-gold transition-colors duration-200 py-2 text-sm font-medium ${
              isRTL ? 'rtl:space-x-reverse' : ''
            }`}
          >
            <span>{t(`navbar.navigation.${item.id}`)}</span>
            {item.hasDropdown && (
              <ChevronDown 
                size={16} 
                className="transition-transform duration-200 group-hover:rotate-180 group-hover:text-gold" 
              />
            )}
          </button>
          
          {item.hasDropdown && (
            <DropdownMenu
              items={item.children?.map(child => child.id === 'featured' ? { ...child, url: '/catalog' } : child)}
              parentId={item.id}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default NavigationMenu